import {
  Card,
  CardContent,
  Box,
  Divider,
  Chip,
  Badge,
  Link
} from '@material-ui/core'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import BoxRow from '../atom/BoxRow'
import Typography from '../base/Typography'

export interface ClientPackageCard {
  assigned: string
  schedule: string[]
  startDate: string
  endDate: string
}

export type ClientPackageCardProps = {
  data: ClientPackageCard[]
  id: number
  status: string
  invisible: boolean
  address: string
  onViewDetailsClick(): void
  code: string
}

const getPackageTag = (
  status: string
): {
  background: string
} => {
  let color = {
    background: '#27AE60'
  }
  if (status === 'Archived') {
    color = {
      background: '#F2994A'
    }
  }
  return color
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardBody: {
      width: 603,
      padding: '9px 0 8px 0'
    },
    divider: {
      color: '#ECECEC',
      margin: '8px 0 8px 0'
    },
    packageCode: {
      padding: '0 4px 0 18px',
      color: '#52798F'
    },
    scheduleTags: {
      '& .MuiChip-label': {
        padding: 0
      },
      color: theme.palette.common.white,
      fontSize: '0.5rem',
      background: '#52798F',
      height: 24,
      width: 'fit-content',
      borderRadius: '2px',
      textAlign: 'center',
      padding: '0px 8px'
    },
    packageTags: (props: ClientPackageCardProps) => ({
      '& .MuiChip-label': {
        padding: 0
      },
      color: theme.palette.common.white,
      borderRadius: '2px',
      height: 'auto',
      fontWeight: 700,
      fontSize: '0.5rem',
      lineHeight: '1.5em',
      alignItems: 'center',
      padding: '3px 6px',
      margin: '0 0 0 15px',
      ...getPackageTag(props.status)
    }),
    linkStyle: {
      color: '#3384FD',
      cursor: 'pointer',
      margin: '0 16px 0 0',
      textAlign: 'right'
    },
    jobId: {
      width: '5%',
      marginRight: theme.spacing(2)
    },
    assignedColumn: {
      width: '20%',
      marginRight: theme.spacing(2)
    },
    jobSchedule: {
      width: '50%',
      marginRight: theme.spacing(2)
    },
    dateSchedule: {
      width: '25%'
    }
  })
)

const ClientPackageCards: React.FC<ClientPackageCardProps> = (props) => {
  const {
    data,
    id,
    code,
    status,
    invisible,
    onViewDetailsClick,
    children,
    address,
    ...rest
  } = props
  const classes = useStyles(props)
  return (
    <Card {...rest}>
      <CardContent className={classes.cardBody}>
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Badge color="error" variant="dot" invisible={invisible}>
              <Typography className={classes.packageCode} bodyVariants="xsBold">
                {props.code}
              </Typography>
              <Typography bodyVariants="xsMedium">{`- Package #${props.id}`}</Typography>
            </Badge>
            <Chip className={classes.packageTags} label={props.status} />
          </Box>
          <Box>
            <Link underline="always" onClick={onViewDetailsClick}>
              <Typography className={classes.linkStyle} variant="overline">
                View Details
              </Typography>
            </Link>
          </Box>
        </Box>
        <Divider className={classes.divider} />
        <Box px={2} py={1}>
          <BoxRow direction="column" gap={1}>
            <Typography bodyVariants="xsMedium">Service Address</Typography>
            <Typography variant="overline">{address}</Typography>
          </BoxRow>
          <Box mt={2}>
            <BoxRow>
              <Typography className={classes.jobId} bodyVariants="xsMedium">
                Job
              </Typography>
              <Typography
                className={classes.assignedColumn}
                bodyVariants="xsMedium"
              >
                Assigned to
              </Typography>
              <Typography
                className={classes.jobSchedule}
                bodyVariants="xsMedium"
              >
                Job Schedule
              </Typography>
              <Typography
                className={classes.dateSchedule}
                bodyVariants="xsMedium"
              >
                Schedule Date
              </Typography>
            </BoxRow>
            {data.map((card, index) => (
              <Box mt={1} key={index} display="flex">
                <Box className={classes.jobId}>
                  <Typography variant="overline">{index + 1}</Typography>
                </Box>
                <Box className={classes.assignedColumn}>
                  <Typography variant="overline">{card.assigned}</Typography>
                </Box>
                <BoxRow
                  className={classes.jobSchedule}
                  gridGap={4}
                  flexWrap="wrap"
                  display="flex"
                  justifyContent="space-between"
                >
                  {card.schedule.map((sessionDay, index) => (
                    <Chip
                      key={index}
                      label={sessionDay}
                      className={classes.scheduleTags}
                    />
                  ))}
                </BoxRow>
                <Box
                  className={classes.dateSchedule}
                  display="flex"
                  gridGap={4}
                  alignItems="flex-start"
                >
                  <Typography variant="overline">{card.startDate}</Typography>
                  <Typography variant="overline"> - </Typography>
                  <Typography variant="overline">{card.endDate}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
export default ClientPackageCards
